<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">
        广州市范围内的冷藏车在线数量：{{ vehicleNumber }}
      </p>
      <p class="titleText">{{ title }}</p>
      <el-select
        class="sel-user"
        v-model="selUser"
        placeholder="请选择"
        @change="handleChangeUser"
      >
        <el-option
          v-for="item in useList"
          :key="item.userId"
          :label="item.userName"
          :value="item.userId"
        >
        </el-option>
      </el-select>
    </section>
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <div
          class="chartPanel-child topLeft"
          v-loading="topLeftLoading"
          element-loading-background="rgba(255, 255, 255, 1)"
        >
          <div class="chartPanel_title">
            <span>·</span>{{ titleName }}冷链配送企业排行Top5
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="topLeftChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--topRight-->
        <div
          class="chartPanel-child topRight"
          v-loading="topRightLoading"
          element-loading-background="rgba(255, 255, 255, 1)"
        >
          <div class="chartPanel_title">
            <span>·</span>{{ titleName }}冷库容积排行
            <span class="chartPanel-child-slide">冷库容积(立方米)</span>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="topRightChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--centerMap-->
        <div
          class="chartPanel-child middleCenter"
          v-loading="mapLoading"
          element-loading-background="rgba(255, 255, 255, 1)"
        >
          <div class="chartPanel-child-chartArea" ref="page_center-map"></div>
        </div>
        <!--bottomLeft-->
        <div
          class="chartPanel-child bottomLeft"
          element-loading-background="rgba(255, 255, 255, 1)"
          v-loading="bottomLeftLoading"
        >
          <div class="chartPanel_title"><span>·</span>冷链运输雷达图</div>
          <div class="switch-content">
            <div>
              <span
                class="switch-box"
                :class="active === 1 ? 'active-box' : ''"
                @click="activeChange(1)"
                >省份</span
              ><span
                class="switch-box"
                :class="active === 2 ? 'active-box' : ''"
                @click="activeChange(2)"
                >省内市</span
              >
            </div>
          </div>
          <div
            v-show="active === 1"
            class="chartPanel-child-chartArea"
            ref="bottomLeftChartDOM"
            style="font-size: 1rem"
          ></div>
          <div
            v-show="active === 2"
            class="chartPanel-child-chartArea"
            ref="bottomRightChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--centerRight-->
        <div
          class="chartPanel-child centerRight"
          v-loading="centerRightLoading"
          element-loading-background="rgba(255, 255, 255, 1)"
        >
          <div class="chartPanel_title">
            <span>·</span>{{ titleName }}物流节点流量Top5
            <span class="chartPanel-child-slide">进出次数(次)</span>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="centerRightChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--bottomRight-->
        <div
          class="chartPanel-child bottomRight"
          v-loading="bottomRightLoading"
        >
          <div class="chartPanel-child-chartArea">
            <div class="chartPanel_title">
              <span>·</span>{{ titleName }}冷配企业与物流节点关联度排行
            </div>
            <el-table
              :data="tableData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              header-row-class-name="header-box"
            >
              <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="企业"
                align="center"
                header-align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="countNum"
                label="车辆进出次数"
                width="120"
                align="center"
                header-align="center"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
import { mapGetters, mapMutations } from "vuex";
import {
  getUserBoardInfo,
  getboardUserListt,
  getComparyVehicleOrderNewForCity,
  FetchStorageTonnageOrder,
  getCompanyAndInOutAreaFlow,
  getInOutAreaFlow,
  getFlowMapData
} from "@/api/board/alarm";
import {
  FetchNumberByAreaName,
  FetchCompanyInfoByCity
} from "@/api/home/gdHome.js";
import echartsHome from "./echartsHome.js";
import {
  handleMapData,
  converVehicleData,
  handleCityData
} from "./gdChartConfig.js";
// mixins
import resizeListener from "_private/mixins/resizeListener";

export default {
  mixins: [resizeListener],
  data() {
    return {
      lineData: "",
      active: 1,
      title: "",
      titleName: "",
      areaName: "",
      vehicleNumber: 0,
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔
      useList: [],
      selUser: "",
      /************ topLeft ****************/
      topLeftLoading: false, // 左上角数据正在加载
      /*********** topRight ********************/
      topRightLoading: false, // 右上角数据正在加载
      /*********** centerRight ********************/
      centerRightLoading: false, // 左下角数据正在加载
      bottomRightLoading: false,
      /*********** bottomLeft ********************/
      bottomLeftLoading: false, // 左下角数据正在加载
      /************* centerMap ********************/
      mapChartData: {
        companyList: [],
        freezerList: [],
        storageList: []
      },
      mapLoading: false,
      isGoDown: true, // 是否下钻地图
      tableData: [],
      mapChartHighlightTimer: null,
      echartsMapObj: null
    };
  },

  created() {
    !this.isFullScreen && this.updateFullScreen();
  },

  mounted() {
    this.getChildUserData(); // 获取自己及其子用户
    this.initMap();
    this.getFlowMapData();
    this.$nextTick(() => {
      echartsHome.resizeEcharts();
    });
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
  },

  computed: {
    ...mapGetters(["isFullScreen", "userId"])
  },

  methods: {
    activeChange(index) {
      this.active = index;
      if (index === 1) {
        this.initBottomLeftChart();
      } else {
        this.initBottomRightChart();
      }
    },
    ...mapMutations(["updateFullScreen"]),
    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    // 监控浏览器及元素变化
    resizeListener() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.clientWidth = document.documentElement.clientWidth;
          this.clientHeight = document.documentElement.clientHeight;
        });
      }, 300);
    },
    // 渐变色
    setLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        0,
        1,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    // 渐变色
    setHLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        1,
        0,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    // 获取当前用户看板的地图code及标题
    async getUserBoardData() {
      try {
        let res = await getUserBoardInfo({
          userId: this.selUser || ""
        });
        this.title = res.result.coldName || "";
        this.titleName = res.result.cityName ? res.result.cityName : "广州";
        this.areaName = res.result.areaName ? res.result.areaName : "广东省";
        this.lineData = res.result.polyline;
        this.bin = res.result.bin;
        document.title = this.title;
        this.initMap();
      } catch (err) {
        console.log(err);
      }
    },
    // 获取当前用户看板的地图code及标题
    async getChildUserData() {
      try {
        let res = await getboardUserListt();
        this.useList = res.result;
        this.selUser = this.useList[0].id;
        this.getUserBoardData();
        this.fetchTopLeftChartData();
        this.fetchTopRightData();
        this.getLogisticsHingeData();
        this.fetchBottomRightData();
      } catch (err) {
        console.log(err);
      }
    },
    // 处理选择用户
    async handleChangeUser() {
      this.getUserBoardData();
      this.fetchTopLeftChartData();
      this.fetchTopRightData();
      this.getLogisticsHingeData();
      this.fetchBottomRightData();
    },
    /************************** topLeft ************************************/
    // 城市冷配车企业Top5接口
    async fetchTopLeftChartData() {
      try {
        this.topLeftLoading = true;
        const res = await getComparyVehicleOrderNewForCity({
          userId: this.selUser
        });
        if (res.code === 1) {
          this.initTopLeftChart(res.result);
        }
      } finally {
        this.topLeftLoading = false;
      }
    },
    // 初始化左上角图表
    initTopLeftChart(data) {
      const dataX = [],
        dataValue = [];
      data.forEach(item => {
        dataX.push(item.name);
        dataValue.push(item.countNum);
      });
      echartsHome.drawTopChart(this.$refs.topLeftChartDOM, {
        dataX,
        dataValue
      });
    },
    /************************** topRight ************************************/
    // 广州市冷库自来水排行
    async fetchTopRightData() {
      try {
        this.topRightLoading = true;
        const res = await FetchStorageTonnageOrder({ userId: this.selUser });
        if (res.code === 1) {
          this.initTopRightChart(res.result);
        }
      } finally {
        this.topRightLoading = false;
      }
    },
    // 初始化右上角图表
    initTopRightChart(data) {
      const dataList = [];
      data.forEach(item => {
        dataList.push({ name: item.name, value: item.countNum });
      });
      echartsHome.drawCellTopChart(this.$refs.topRightChartDOM, {
        category: dataList
      });
    },
    /*****************************中间部分地图数据*************************/
    // 初始化地圖
    async initMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`),
        import(`@/assets/geo/${geoDirName}/guangzhou/outline.json`)
      ];
      let [inlineGeo, outlineGeo, guangdongOutlineGeo] = await Promise.all(
        geoPromises
      );
      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      this.mapGuangdongOutlineGeo = Object.freeze(guangdongOutlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      await this.getMapData();
    },
    // 请求数据
    async getMapData() {
      try {
        if (
          this.areaName !== "广东省" &&
          this.areaName !== "东沙群岛" &&
          this.areaName
        ) {
          let code = this.conversion(this.areaName);
          let json = await import(
            `@/assets/geo/guangdong/couties/${code}.json`
          );
          // 初始化地图
          Echarts.registerMap(this.areaName + "inlineMap", json);
          this.fetchCenterCompanyData(this.areaName, this.bin);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 初始化地图echarts
    async initMapEcharts(cityName = "", data = {}) {
      const mapChartData = data;
      const option = {
        legend: {
          data: ["车辆", "冷库", "企业"],
          orient: "horizontal",
          textStyle: {
            color: "#666"
          },
          top: "2%",
          left: 20
        },
        tooltip: {
          show: true
        },
        visualMap: {
          show: true,
          type: "piecewise",
          right: 10,
          bottom: 20,
          calculable: true,
          seriesIndex: [3],
          hoverLink: false,
          // 数据颜色范围，值越大颜色越深
          pieces: [
            {
              min: 100,
              color: this.setLinearColor("#006FEC", "#3B45F4")
            },
            {
              min: 76,
              max: 100,
              color: this.setLinearColor("#2B84EF", "#5B63F6")
            },
            {
              min: 51,
              max: 75,
              color: this.setLinearColor("#549CF2", "#7A81F7")
            },
            {
              min: 26,
              max: 50,
              color: this.setLinearColor("#7CB3F6", "#999EF9")
            },
            {
              min: 0,
              max: 25,
              color: this.setLinearColor("#A4CAF9", "#B8BCFB")
            }
          ]
        },
        geo: {
          name: cityName + "inlineMap",
          type: "map",
          map: cityName + "inlineMap",
          roam: true,
          zoom: 1,
          top: "5%",
          bottom: "5%",
          left: "5%",
          right: "13%",
          tooltip: {
            show: false
          },
          label: {
            normal: {
              show: true,
              position: "inside", //显示位置
              offset: [0, 0], //偏移设置
              color: "#fff",
              textShadowColor: "rgba(0,0,0,0.3)",
              textShadowBlur: 2,
              textShadowOffsetX: 0,
              textShadowOffsetY: 4,
              fontWeight: "lighter",
              fontSize: 12
            },
            emphasis: {
              color: "#fff"
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#2E48F3"
            }
          },
          regions: [
            {
              name: "",
              itemStyle: {
                areaColor: {
                  type: "radial",
                  x: 0.5,
                  y: 0.5,
                  r: 0.5,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(35, 242, 255, 0.9)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(35, 242, 255, 0.7)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              label: {
                show: true,
                fontSize: 12, //未选中时字体的大小
                color: "#333" //未选中时字体的颜色
              },
              emphasis: {
                itemStyle: {
                  areaColor: "#2E48F3", // 高亮时候地图显示的颜色
                  borderWidth: 1 // 高亮时的边框宽度
                },
                label: {
                  fontSize: 12, // 选中地图文字字号和字体颜色
                  color: "#fff"
                }
              },
              selected: true,
              select: {
                itemStyle: {
                  areaColor: "#da0010", // 高亮时候地图显示的颜色
                  borderWidth: 1 // 高亮时的边框宽度
                },
                label: {
                  fontSize: 12, // 选中地图文字字号和字体颜色
                  color: "#fff"
                }
              }
            }
          ]
        },
        series: [
          {
            name: "企业",
            type: "scatter",
            coordinateSystem: "geo",
            itemStyle: {
              color: "#FF9600" //波纹圈颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">企业:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#FF9600;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
              //css样式，用于换行。
            },
            data: mapChartData.companyList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#00B7F4"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">冷库:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#00B7F4;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "车辆",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#01AF3C"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <div style="font-size:14px;margin:0px">车辆:</div>
                  <div style="font-size:14px;margin:0px"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#01AF3C;margin-right:5px;"></span>${params.name}</div>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleLat
          },
          {
            type: "map",
            map: cityName + "inlineMap",
            geoIndex: 0,
            roam: true,
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <p style="font-size:18px;margin:0px">${params.name}</p>
                  <p>
                    <span style="display:block;margin:5px 0">入住企业总数：${params.data.comparyNum}</span>
                    <span style="display:block;margin:5px 0">车辆总数：${params.value}</span>
                    <span style="display:block;margin:5px 0">冷库总数：${params.data.storageNum}</span>
                    <span style="display:block;margin:5px 0">冷柜总数：${params.data.freezerNum}</span>
                  </p>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleList,
            label: {
              emphasis: {
                show: false
              },
              normal: {
                show: false
              }
            }
          }
        ]
      };
      option.geo.regions[0].name = this.areaName;
      if (this.echartsMapObj) {
        this.echartsMapObj.clear();
      }
      this.echartsMapObj = Echarts.init(this.$refs["page_center-map"]);
      this.echartsMapObj.setOption(option);
      window.addEventListener("resize", () => {
        this.echartsMapObj.resize();
      });
      this.echartsMapObj.on("georoam", params => {
        if (params.dy || params.dx) return;
        let _option = this.echartsMapObj.getOption();
        this.echartsMapObj.clear(); //清空
        this.echartsMapObj.setOption(_option);
      });
      // this.echartsMapObj.on("mouseup", params => {
      //   let _option = this.echartsMapObj.getOption();
      //   this.echartsMapObj.clear(); //清空
      //   this.echartsMapObj.setOption(_option);
      // });
      // this.echartsMapObj.on("click", this.dropdown);
      // this.isGoDown && this.echartsMapObj.on("dblclick", this.dropUp);
    },
    // 下钻城市
    // async dropdown(params) {
    //   if (params.componentSubType !== "map") return;
    //   if (
    //     !this.isGoDown ||
    //     params.name === "广东省" ||
    //     params.name === "东沙群岛"
    //   )
    //     return;
    //   let code = this.conversion(params.name);
    //   let json = await import(`@/assets/geo/guangdong/couties/${code}.json`);
    //   // 初始化地图
    //   Echarts.registerMap(params.name + "inlineMap", json);
    //   this.fetchCenterCompanyData(params.name, params.data.bin);
    //   this.isGoDown = false;
    // },
    // 获取地图下钻二级市，区，县数据
    async fetchCenterCompanyData(cityName = "", bin) {
      try {
        this.mapLoading = true;
        let that = this;
        let [res, vehicleData] = await Promise.all([
          FetchCompanyInfoByCity({ cityName }),
          FetchNumberByAreaName(this.$qs.stringify({ bin: bin }))
        ]);
        if (res && vehicleData) {
          if (res.code === 1 && res.result) {
            that.mapChartData = {
              companyList: handleCityData(
                res.result.companyLonLatList || [],
                this.lineData
              ),
              freezerList: handleMapData(
                res.result.freezerLonLatList || [],
                this.lineData
              ),
              storageList: handleMapData(
                res.result.storageLonLatList || [],
                this.lineData
              ),
              vehicleLat: this.filterVehicle(
                handleMapData(res.result.vehicleLonLatList || [], this.lineData)
              ),
              vehicleList: converVehicleData(vehicleData.result || [], "count")
            };
            this.initMapEcharts(cityName, that.mapChartData);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 筛选当前的车辆列表，将不属于当前地图的点过滤掉
    filterVehicle(vehicleList) {
      // // 地图轮廓多边形的点的数据
      // const polygonPoints = this.mapGuangdongOutlineGeo.features[0].geometry
      //   .coordinates[0][0];
      // // console.log(polygonPoints, "范围");
      // let result = null;
      // // 过滤掉不属于该地区的点
      // result = vehicleList.filter(item => {
      //   if (this.isInPolygon(item.value, polygonPoints)) {
      //     return item;
      //   }
      // });
      // return result;
      // 地图轮廓多边形的点的数据;
      let arr = [];
      this.mapOutlineGeo.features.forEach(f => {
        let polygonPoints = "";
        if (this.mapOutlineGeo.cp) {
          polygonPoints = f.geometry.coordinates[0];
        } else {
          polygonPoints = f.geometry.coordinates[0][0];
        }

        let result = null;
        // 过滤掉不属于该地区的点
        result = vehicleList.filter(item => {
          if (this.isInPolygon(item.value, polygonPoints)) {
            return item;
          }
        });
        arr.push(...result);
      });
      return arr;
    },
    /**
     * 判断当前点是否再地图 geoJSON 的多边形范围之内
     * @param {array} checkPoint 要判断的经纬度
     * @param {array} polygonPoints geoJSON 中的多边形数据
     * @return {boolean} 返回是否再当前多边形范围之内
     */
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0;
      let i;
      let xinters;
      let p1, p2;
      let pointCount = polygonPoints.length;
      p1 = polygonPoints[0];

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount];
        if (
          checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
        ) {
          if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
            if (p1[0] != p2[0]) {
              xinters =
                ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
                p1[1];
              if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                counter++;
              }
            }
          }
        }
        p1 = p2;
      }
      if (counter % 2 == 0) {
        return false;
      } else {
        return true;
      }
    },
    // 返回上一层
    dropUp() {
      this.getMapData();
      this.isGoDown = true;
    },
    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1920) * this.clientWidth;
    },
    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1080) * this.clientHeight;
    },
    // 千分符处理
    handleData(data) {
      let regex = /\d{1,3}(?=((\d{3})+$))/g;
      if ((data + "").indexOf(".") > -1) {
        regex = /\d{1,3}(?=((\d{3})+\.))/g;
      }
      let str = (data + "").replace(regex, "$&,");
      // let str = data.toLocaleString();
      return str;
    },
    conversion(name) {
      let code = 0;
      switch (name) {
        case "湛江市":
          code = 440800;
          break;
        case "茂名市":
          code = 440900;
          break;
        case "阳江市":
          code = 441700;
          break;
        case "江门市":
          code = 440700;
          break;
        case "云浮市":
          code = 445300;
          break;
        case "珠海市":
          code = 440400;
          break;
        case "中山市":
          code = 442000;
          break;
        case "佛山市":
          code = 440600;
          break;
        case "肇庆市":
          code = 441200;
          break;
        case "深圳市":
          code = 440300;
          break;
        case "东莞市":
          code = 441900;
          break;
        case "广州市":
          code = 440100;
          break;
        case "清远市":
          code = 441800;
          break;
        case "惠州市":
          code = 441300;
          break;
        case "韶关市":
          code = 440200;
          break;
        case "汕尾市":
          code = 441500;
          break;
        case "河源市":
          code = 441600;
          break;
        case "揭阳市":
          code = 445200;
          break;
        case "梅州市":
          code = 441400;
          break;
        case "汕头市":
          code = 440500;
          break;
        case "潮州市":
          code = 445100;
          break;
        default:
          code = 440100;
      }
      return code;
    },
    /************************** centerLeft ************************************/
    // 物流枢纽流量Top5
    async getLogisticsHingeData() {
      try {
        this.centerRightLoading = true;
        const res = await getInOutAreaFlow({ userId: this.selUser });
        if (res.code === 1) {
          this.initcenterRightChart(res.result);
        }
      } finally {
        this.centerRightLoading = false;
      }
    },
    initcenterRightChart(data) {
      const dataX = [],
        dataValue = [];
      data.forEach(item => {
        dataX.push(item.name);
        dataValue.push(item.countNum);
      });
      echartsHome.drawBevellChart(this.$refs.centerRightChartDOM, {
        dataX,
        dataValue
      });
    },
    /************************** bottomLeft ************************************/
    async getFlowMapData() {
      try {
        this.bottomLeftLoading = true;
        const res = await getFlowMapData();
        if (res.code === 1) {
          this.flowMapData = res.result && JSON.parse(res.result);
          this.initBottomLeftChart();
        }
      } finally {
        this.bottomLeftLoading = false;
      }
    },
    // 初始化底部左侧柱状图
    initBottomLeftChart() {
      this.$nextTick(() => {
        echartsHome.drawFlowMapChart(
          this.$refs.bottomLeftChartDOM,
          this.flowMapData.chinaDatas
        );
      });
    },
    // 初始化底部左侧柱状图
    initBottomRightChart() {
      this.$nextTick(() => {
        echartsHome.drawProvincesFlowMapChart(this.$refs.bottomRightChartDOM, {
          point_circle: this.flowMapData.point_circle,
          point_line: this.flowMapData.point_line
        });
      });
    },
    /************************** bottomRight ************************************/
    // 广州冷配企业与物流节点关联度排行
    async fetchBottomRightData() {
      try {
        this.bottomRightLoading = true;
        const res = await getCompanyAndInOutAreaFlow({ userId: this.selUser });
        if (res.code === 1) {
          this.tableData = res.result;
        }
      } finally {
        this.bottomRightLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(~@/assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(~@/assets/ledFont/LEDNum.eot?#iefix) format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("~@/assets/ledFont/LEDNum.woff") format("woff"),
    local("LEDNum"), url("~@/assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}

$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 0.6rem;
    padding-top: 0.1rem;
    background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    margin-bottom: 0.2rem;

    p {
      margin: 0;
    }

    .titleInfo {
      font-family: "LEDNumber";
      color: #3f83ff;
      font-size: 0.14rem;
      font-weight: bolder;
      word-spacing: 1em;
      margin-left: 0.35rem;
      margin-top: 0.12rem;
    }

    .titleText {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 0.26rem;
      font-weight: bold;
      background-color: #fff;
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      letter-spacing: 4px;
    }
    .sel-user {
      position: absolute;
      right: 10px;
      top: 16px;
      /deep/ .el-input__inner {
        color: #fff;
        background: transparent !important;
        border-color: #134b9a;
      }
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &_title {
        display: flex;
        align-items: center;
        height: 0.35rem;
        line-height: 0.35rem;
      }
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (350px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.topRight {
          right: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (350px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.middleCenter {
          left: 0;
          right: 0;
          top: (70px / $layout-height) * 100%;
          margin: 0 auto;
          width: (936px / $layout-width) * 100%;
          height: 90%;
          .picture-map {
            width: 100%;
            height: 100%;
            position: absolute;
            &.dongguan {
              background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
              background-size: 100% 100%;
            }
            &.zhongshan {
              background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
              background-size: 100% 100%;
            }
          }
          .chartPanel-child-chartArea {
            z-index: 100;
          }
        }
        &.centerLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (335px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
        }
        &.centerRight {
          right: (10px / $layout-width) * 100%;
          bottom: (335px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }
        &.bottomLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (10px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (620px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 96%;
          background-position-y: 100%;
          overflow: hidden;

          .chartPanel-child-chartArea {
            width: 100%;
            height: 80%;
            margin-top: 21%;
            canvas {
              width: 100%;
              height: 100%;
            }
          }

          .switch-content {
            margin-top: 60px;
            text-align: center;
            z-index: 1000;
            & > div {
              display: inline-block;
              width: 200px;
              height: 36px;
              background-color: #eee;
              border-radius: 30px;
              font-size: 14px;
              padding: 4px 6px;
              line-height: 36px;

              .switch-box {
                display: inline-block;
                width: 100px;
                height: 36px;
                border-radius: 30px;
                color: #999;
                cursor: pointer;
              }

              .active-box {
                background-color: #2e48f3;
                color: #fff;
                font-size: 16px;
                font-weight: bolder;
              }
            }
          }
        }

        &.bottomRight {
          right: (10px / $layout-width) * 100%;
          bottom: (10px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .posRight {
            position: absolute;
            width: 2.5rem;
            height: 0.23rem;
            line-height: 0.23rem;
            left: 50%;
            padding-left: 0.1rem;
            top: 1px;
            font-size: 0.16rem;
            background: url("~@/assets/images/alarmBoard/bottom_title_bg.png")
              no-repeat;
          }

          /deep/ .el-table {
            height: 80%;
            margin-top: 0.35rem;
            margin-left: 0.2rem;
            margin-right: 0.1rem;

            th {
              border-left: none;
              color: #333;
            }

            &__header-wrapper {
              height: 0.34rem;
              .cell {
                font-size: 0.13rem;
              }
            }

            & .warning-row {
              height: 0.32rem !important;
              background-color: rgba(175, 190, 255, 0.1) !important;
              .el-table__cell {
                background-color: rgba(175, 190, 255, 0.1) !important;
                height: 0.32rem !important;
              }
            }

            & .success-row {
              .el-table__cell {
                height: 0.32rem !important;
              }
            }
            th.el-table__cell {
              background-color: #afbeff;
            }
            &_row th,
            &_row td {
              border: none;
              height: 0.32rem;
            }
          }
        }
        .chartPanel_title {
          position: absolute;
          width: 100%;
          height: 0.3rem;
          height: 0.25rem;
          top: 0;
          left: 5px;
          color: #000;
          font-size: 0.18rem;
          font-weight: bolder;

          span {
            display: inline-block;
            color: #3f83ff;
            width: 14px;
          }
        }
        &-slide {
          position: absolute;
          width: 120px !important;
          right: 0.05rem;
          display: flex;
          z-index: 10;
          font-size: 0.14rem;

          li {
            margin-left: 0.03rem;
            padding: 0.05rem 0.06rem;
            font-size: 0.12rem;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: #000;
              background: #7b89dc;
              border-radius: 0.05rem;
            }
          }
        }
        span.chartPanel-child-slide {
          color: #000;
        }

        &-chartArea {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
        .w25 {
          width: 25%;
          height: 100%;
        }
        .w50 {
          width: 60%;
          height: 100%;
        }
        .h10 {
          width: 100%;
          height: 10%;
        }
        .h20 {
          width: 100%;
          height: 20%;
        }
        .h30 {
          width: 100%;
          height: 30%;
        }
        .h40 {
          width: 100%;
          height: 40%;
        }
        .h50 {
          width: 100%;
          height: 50%;
        }
        .run_time {
          position: relative;
          .item_title {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            font-size: 0.12rem;
            color: rgba(175, 190, 255, 0.6);
            top: 0.42rem;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
